var config = require("../config");

var urlParamNames = config.get("urlParamNames");

var pLat = urlParamNames[0];
var pLng = urlParamNames[1];

var latReg = new RegExp(pLat + "=([^$&]+)");
var lngReg = new RegExp(pLng + "=([^$&]+)");

module.exports = function (suc, fail, next) {
    var query = location.search;
    var latMatch = query.match(latReg);
    var lngMatch = query.match(lngReg);

    if (latMatch && lngMatch && !isNaN(latMatch[1]) && !isNaN(lngMatch[1])) {
        suc({
            lat: latMatch[1],
            lng: lngMatch[1]
        });
    } else {
        next();
    }
};

module.exports.type = "url";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/url.js